export default "__VITE_ASSET__CUNingRj__"